<template lang="pug">
  v-dialog(
    v-model="dialog"
    v-bind="extendAttrs"
    v-on="extendListeners"
    attach
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")

    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

    v-card.ui-design.ui-bright(
      style="overflow: hidden"
      rounded="xxl"
      elevation="0"
    )
      slot(
        v-if="!hideHeader"
        name="header"
        v-bind="{ close }"
      )
        v-card-title.pa-8.pb-6.mb-1
          h2(v-if="title") {{ title }}
          v-spacer
          slot(
            v-if="!closeIcon"
            name="header.close"
            v-bind="{ close }"
          )
            v-btn(icon @click="close")
              v-icon(color="redesignBlack" size="24") {{ closeIcon }}
        v-card-subtitle.pa-8.pt-0.pb-6.mt-n7(
          v-if="description"
          class="ui-neutral--text"
        ) {{ description }}

      .d-flex.flex-column.pa-8.pt-0.overflow-y-auto(v-if="!hideContent")
        slot(name="content" v-bind="{ close }")

      v-card-actions.pa-8.pt-0(v-if="!hideActions")
        slot(name="actions" v-bind="{ close }")
</template>

<script>
export default {
  name: 'EvDialog',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    hideHeader: { type: Boolean, default: false },
    hideContent: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
    maxHeight: { type: String, default: '90%' },
    closeIcon: { type: String, default: '$ui-close' },
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  computed: {
    styleList() {
      const { $attrs } = this;

      return {
        ...$attrs.style,
        '--dialog-max-height': this.maxHeight,
      };
    },
    extendAttrs() {
      const { $attrs } = this;
      return {
        'card-attrs': {},
        'max-width': 600,
        'overlay-opacity': 0.3,
        scrollable: true,
        ...$attrs,
        style: this.styleList,
      };
    },
    extendListeners() {
      return {
        ...this.$listeners,
        input: (val) => this.$emit('input', val),
      };
    },
  },
  methods: {
    // This construction fixed delete dialog overlay;
    async close() {
      this.$emit('before:close');

      new Promise((resolve) => {
        this.dialog = false;
        resolve();
      }).then(() => {
        this.$emit('close');
      });
    },
  },
};
</script>
